<template>
    <div class="hotline">
        <p>市民热线12345</p>
        <p>
            “12345”市民热线综合服务平台以为民、便民、利民为原则，搭建政府与市民的“连心桥”，受理办理公民、法人和其他组织咨询、求助、建议、表扬、投诉和举报的与政府服务有关的活动,12345市民热线平台监督跟踪工单办理全程，确保每一个市民反映的每一个问题 “件件有着落、事事有回音”。
        </p>
        <img class="hot-line-img" :src="require('@/assets/images/rightBg.png')" />
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    components: {},
};
</script>
<style scoped>


@media screen and (max-width: 765px){
    .hot-line-img{
        display: none;
    }
    body .hotline{
        
    }
}
.hotline{
    position: relative;
    height: 100%;
    background: #306bbb;
}
p {
    margin: 0 33px;
    color: #eef7fd;
    line-height: 30px;
    font-family: Source Han Sans CN;
}
p:nth-child(1) {
    font-size: 30px;
    font-weight: bold;
    text-align: center;
    border-bottom:1px solid #1F59A7;
    padding: 44px 0 20px 0;
}
p:nth-child(2) {
    margin-top: 20px;
    font-size: 14px;
    font-weight: 400;
    text-indent: 2em;
}
img{
    width: 100%;
    height: 201px;
    position: absolute;
    bottom: 0;
}
</style>